var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"add-to-wishlist-button",attrs:{"bem-modifiers":[
        'background-casto-blue',
        'full-width',
        'font-size-small',
        'horizontally-centered' ].concat( _vm.bemModifiers ),"name":_vm.label},nativeOn:{"click":function($event){return _vm.addToWishlist($event)}}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }